<template lang="html">
  <div
    ref="link"
    tabindex="0"
    class="grid-x grid-padding-x inline-link"
    @click="clicked"
    @keyup="clicked"
  >
    <div
      class="small-12 cell vertical-align-middle inline-link-text"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    browserdetect: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mounted() {
  },
  methods: {
    clicked() {
      this.$emit('clicked');
    },
  },
};
</script>

<style lang="scss" scoped>

  /* - Sizing and layout - */

  $grid: 12px;

  /* - Colour - */

  $blur-text-color: #7d8b96;

  .vertical-align-middle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .inline-link {
    background: linear-gradient(to right, black 33%, rgba(255, 255, 255, 0) 0%) bottom repeat-x;
    background-size: 3px 1px;
    display: inline-block;
    height: 2 * $grid;
    margin-bottom: 0.5 * $grid;
  }

  .inline-link-text {
    color: $blur-text-color;
    cursor: pointer;
    font-size: 12px;
    height: 1.5 * $grid;
    letter-spacing: 2px;
    line-height: 1.5;
    padding-left: 0;
    padding-right: 0;
    text-align: left;
    text-transform: uppercase;
  }

</style>
